import React from 'react';
import styled from 'styled-components';
import { SubContainer } from '../../../certificates-constancies/type1/info/components';
import { Block, Icon, Text } from '../../../../../../components';
import Step from '../../UpdatePhoto/Register/components/Step';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import { SaveButton } from '../../../scholarships/bse/components/styled';
import Select from '../../../../../../reusables/Select';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import Spinner from '@/presentation/components/Spinner';
import Processing from '@/presentation/components/Processing';
import ModalConfirmation from '@/presentation/modules/procedures/components/Modal/Modal';
import ConfirmationQuit from '../../UpdatePhoto/Register/components/ConfirmationQuit';
import ModuleContainer from '@/presentation/components/Container';
import Back from '@/presentation/reusables/Button/Back';

const Container = styled.div`
  color: #161d1f;
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  margin: 16px 0px 32px 0px;
  width: 100%;
`;

interface LateExamenRegisterViewProps {
  handlerBackButton: () => void;
  handlerChangeCourse: (e: any) => void;
  handlerChangeTest: (e: any) => void;
  handleCancelquit: () => void;
  handleQuit: () => void;
  selectCourse: any;
  selectTest: any;
  onSubmit: () => void;
  stepsProcedure: any;
  listCourses: any[];
  listExams: any;
  isLoadingCoursesinfo: boolean;
  isProcessingRegister: boolean;
  showExamNoCost: boolean;
  isQuit: boolean;
}

const getCourses = (list: any[]) => {
  if (list.length === 0) {
    return [];
  }
  return list.map((course) => ({
    value: course.id,
    name: course.name
  }));
};

const LateExamenRegisterView = ({
  handlerBackButton,
  handlerChangeCourse,
  handlerChangeTest,
  handleCancelquit,
  handleQuit,
  selectCourse,
  selectTest,
  onSubmit,
  stepsProcedure,
  listCourses,
  listExams,
  isLoadingCoursesinfo,
  isProcessingRegister,
  showExamNoCost,
  isQuit
}: LateExamenRegisterViewProps) => (
  <ModuleContainer
    containerType="subsection"
    data-testid="cmp-LateExamRegisterView"
  >
    <div style={{ paddingTop: 16, paddingBottom: 12 }}>
      <Back dataTestid="cmp-buttom-back-refactor" onClick={handlerBackButton} />
    </div>
    {isLoadingCoursesinfo && <Spinner />}
    {!isLoadingCoursesinfo && (
      <SubContainer>
        <Processing isOpen={isProcessingRegister} />
        <ToggleHeader
          name={stepsProcedure?.name}
          amount={stepsProcedure?.amount}
          duration={stepsProcedure?.duration}
          date={stepsProcedure?.endDate}
          star="*"
          childContent={<ProcedureInfoComponent inRegister />}
        />
        <TextTitle title="Progreso" />
        <Block customized padding="28px 0px 45px 8px">
          <Step
            name={stepsProcedure?.steps[0].name}
            order={stepsProcedure?.steps[0].order}
          >
            <Container>
              <p style={{ marginBottom: 16 }}>
                Selecciona el tipo de curso que quieres rezagar. Recuerda que
                solo se muestran los que tienes <b>{'NS (no se presentó)'}.</b>
              </p>
              <Select
                items={listCourses && getCourses(listCourses)}
                onChange={handlerChangeCourse}
                value={selectCourse}
                placeholder="Selecciona un curso"
                itemCount={2}
                itemName={'name'}
                itemValue={'value'}
                label={'Cursos'}
              />
              <br />
              <Select
                isDisabled={!selectCourse}
                items={listExams}
                onChange={handlerChangeTest}
                value={selectTest}
                placeholder="Selecciona examen"
                itemCount={2}
                itemName={'name'}
                itemValue={'value'}
                label={'Tipo de examen'}
              />
              {showExamNoCost && (
                <Block
                  customized
                  minHeight="32px"
                  padding="6px 0px 24px 0px"
                  borderRadius="8px"
                  flexDirection="row"
                >
                  <Icon name="alert-circle" size="16px" color="#977100" />
                  <Block customized margin="0px 0px 0px 8px">
                    <Text
                      color="#161D1F"
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="400"
                      textAlign="left"
                    >
                      Este examen{' '}
                      <span style={{ fontWeight: '600' }}>
                        no tendrá costo,
                      </span>{' '}
                      por lo que se te exonera del pago.
                    </Text>
                  </Block>
                </Block>
              )}

              {listCourses?.length === 0 && (
                <Block
                  customized
                  minHeight="32px"
                  padding="6px 0px 24px 0px"
                  borderRadius="8px"
                  flexDirection="row"
                >
                  <Icon name="alert-circle" size="16" />
                  <Block customized margin="0px 0px 0px 8px">
                    <Text
                      color="#161D1F"
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="400"
                      textAlign="left"
                    >
                      No cuentas con ningún curso por rezagar.
                    </Text>
                  </Block>
                </Block>
              )}
              {!showExamNoCost && listCourses?.length !== 0 && <br />}

              <SaveButton
                type="button"
                onClick={onSubmit}
                data-testid="btn-register-stragglers"
                disabled={!(selectCourse && selectTest)}
              >
                Solicitar
              </SaveButton>
            </Container>
          </Step>
          <Step
            name={stepsProcedure?.steps[1]?.name}
            order={stepsProcedure?.steps[1]?.order}
            disabled
          />
          <Step
            name={stepsProcedure?.steps[2]?.name}
            order={stepsProcedure?.steps[2]?.order}
            isLast
            disabled
          />
        </Block>
      </SubContainer>
    )}
    <ModalConfirmation show={isQuit} handleClose={handleCancelquit}>
      <ConfirmationQuit
        handleQuit={handleQuit}
        handleCancel={handleCancelquit}
      />
    </ModalConfirmation>
  </ModuleContainer>
);

export default LateExamenRegisterView;
